import {billingQuoteSvg as Icon__small__billingQuoteSvg} from '../Icon__small/Icon__small--billingQuote.js';

export var billingQuote = {
  name: 'billingQuote',
  category: 'icon',
  colorable: true,
  svg: Icon__small__billingQuoteSvg,
};
